import React from 'react';
import { Box, Button, Link, Typography } from '@mui/material';
import ProvetLogo from '../../../assets/images/Provet.svg';

const PROVET_INTEGRATION_URL = 'https://www.cetravets.com/provet-cetra-for-vets-integration';

// SettingsIntegrations renders the Provet integration panel in account settings.
const SettingsIntegrations = ({ sectionSx = {} }) => {
    const openLinkProps = {
        href: PROVET_INTEGRATION_URL,
        target: '_blank',
        rel: 'noopener noreferrer',
    };

    return (
        <Box
            className="settings-block"
            sx={{
                backgroundColor: 'white',
                border: '1px solid rgba(102, 102, 102, 0.15)',
                padding: { xs: '22px 30px 30px', md: '24px 30px 22px' },
                borderRadius: '30px',
                marginBottom: '24px',
                overflow: 'hidden',
                ...sectionSx,
            }}
        >
            <Typography
                variant="h5"
                sx={{
                    color: '#000453',
                    fontSize: { xs: '24px', md: '28px' },
                    fontWeight: 600,
                    lineHeight: { xs: '24px', md: '28px' },
                    letterSpacing: { xs: '-0.48px', md: '-0.56px' },
                    mb: { xs: '42px', md: '44px' },
                }}
            >
                Integrations
            </Typography>

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    alignItems: { xs: 'stretch', md: 'flex-start' },
                    gap: { xs: '24px', md: '60px' },
                    mb: { xs: '28px', md: '36px' },
                }}
            >
                <Box sx={{ minWidth: { md: 277 }, flexShrink: 0 }}>
                    <Box
                        component="img"
                        src={ProvetLogo}
                        alt="Provet"
                        sx={{
                            display: 'block',
                            width: { xs: 248, md: 277 },
                            height: 'auto',
                            mb: '8px',
                        }}
                    />
                    <Link
                        {...openLinkProps}
                        sx={{
                            color: '#FF669B',
                            fontSize: { xs: '12px', md: '14px' },
                            fontWeight: 400,
                            lineHeight: { xs: '12px', md: '14px' },
                            letterSpacing: { xs: '-0.24px', md: '-0.28px' },
                            textDecorationColor: '#FF669B',
                            '&:hover': { color: '#FF669B' },
                        }}
                    >
                        How to integrate with Provet
                    </Link>
                </Box>

                <Box
                    sx={{
                        width: { xs: '100%', md: 424 },
                        maxWidth: { xs: 290, md: 'none' },
                        minHeight: { xs: 67, md: 98 },
                        alignSelf: { xs: 'center', md: 'auto' },
                        display: 'flex',
                        alignItems: 'center',
                        gap: { xs: '10px', md: '14px' },
                        background: '#F0F0FC',
                        border: { xs: '1px dashed rgba(0, 4, 83, 0.2)', md: '1.4px dashed rgba(0, 4, 83, 0.2)' },
                        borderRadius: { xs: '10px', md: '14px' },
                        px: { xs: '14px', md: '18px' },
                        py: { xs: '10px', md: '16px' },
                    }}
                >
                    <Box
                        sx={{
                            width: { xs: 42, md: 54 },
                            height: { xs: 42, md: 54 },
                            borderRadius: '50%',
                            background: '#000453',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: { xs: '28px', md: '36px' },
                            fontWeight: 700,
                            lineHeight: 1,
                            flexShrink: 0,
                        }}
                    >
                        ?
                    </Box>
                    <Box sx={{ minWidth: 0 }}>
                        <Typography
                            sx={{
                                color: '#000453',
                                fontSize: { xs: '14px', md: '18px' },
                                fontWeight: 600,
                                lineHeight: { xs: '14px', md: '18px' },
                                letterSpacing: { xs: '-0.56px', md: '-0.72px' },
                                mb: { xs: '4px', md: '5px' },
                            }}
                        >
                            More integrations are on the way!
                        </Typography>
                        <Typography
                            sx={{
                                color: '#000453',
                                fontSize: { xs: '10px', md: '14px' },
                                fontWeight: 400,
                                lineHeight: { xs: '14px', md: '18px' },
                                letterSpacing: { xs: '-0.4px', md: '-0.56px' },
                            }}
                        >
                            We&rsquo;re in the process of adding new partners to help streamline your workflow
                        </Typography>
                    </Box>
                </Box>
            </Box>

            <Button
                component="a"
                {...openLinkProps}
                variant="contained"
                disableElevation
                sx={{
                    width: '100%',
                    height: { xs: 39, md: 37 },
                    borderRadius: '155px',
                    backgroundColor: '#FF669B',
                    color: '#fff',
                    fontSize: { xs: '14px', md: '16px' },
                    fontWeight: 500,
                    lineHeight: { xs: '14px', md: '16px' },
                    letterSpacing: { xs: '-0.28px', md: '-0.32px' },
                    textTransform: 'none',
                    '&:hover': {
                        backgroundColor: '#FF85B0',
                    },
                }}
            >
                Get started
            </Button>
        </Box>
    );
};

export default SettingsIntegrations;
